export default function Admin() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Admin Panel</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-4">User Management</h3>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span>Total Users:</span>
              <span className="font-semibold">12</span>
            </div>
            <div className="flex justify-between">
              <span>Active Sessions:</span>
              <span className="font-semibold">8</span>
            </div>
            <div className="flex justify-between">
              <span>Admin Users:</span>
              <span className="font-semibold">3</span>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-4">System Health</h3>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span>Database Status:</span>
              <span className="font-semibold text-green-600">Healthy</span>
            </div>
            <div className="flex justify-between">
              <span>API Response Time:</span>
              <span className="font-semibold">45ms</span>
            </div>
            <div className="flex justify-between">
              <span>Uptime:</span>
              <span className="font-semibold">99.9%</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}